import DeleteStat from "./DeleteStat";
export default DeleteStat;
